export default "__VITE_ASSET__C$ioJw9h__"